

import React, { memo, useState, useRef, useMemo, useEffect } from 'react';
import SocialIteration from './SocialIterationV2';
import NewOutput from '../../SocialIterations/components/NewOutput';

import { canUpdateOutput } from '../../../common/utils';
import ToggleValueAddon from '../../Addons/components/Expandable/components/ToggleValueAddon';

import '../styles/_social-iterations-v2.scss';

const SMALL_BREAKPOINT = 639;
const SMALL_BREAKPOINT_MODAL = 500;



























function getIsMobile({
  isEditingMode,
  width



}) {
  if (isEditingMode) {
    return width <= SMALL_BREAKPOINT_MODAL;
  }

  return width <= SMALL_BREAKPOINT;
}

function onDeleteOutput({
  index,
  setIterationsVisibility,
  additionalOutputs,
  deleteOutput





}) {
  if (additionalOutputs.length === 1) {
    setIterationsVisibility(false);
  }

  deleteOutput(index);
}

function SocialIterations({
  assets,
  outputCost,
  outputs,
  hasUpdatePermission,
  canUpdateVideo,
  onSave,
  handleNotesChange,
  onChangeAddon,
  setInitialOutput,
  createNewOutput,
  deleteOutput,
  updateOutputName,
  onChangeCost,
  getCurrencySymbol,
  getCurrencyIcon,
  editingMode,
  projectType = ''
}) {
  const [areIterationsVisible, setIterationsVisibility] = useState(
    Boolean(outputs.length > 1)
  );

  const isPodcast = projectType === 'PODCAST';

  const iterationsBlockRef = useRef();

  const iterationsWidth = useMemo(
    () => iterationsBlockRef.current?.offsetWidth || 0,
    [iterationsBlockRef.current?.offsetWidth]
  );

  const isMobile = useMemo(
    () => getIsMobile({ width: iterationsWidth, isEditingMode: editingMode }),
    [iterationsWidth, editingMode]
  );

  const masterOutputIndex = outputs.findIndex((output) => output.isMaster);
  const masterOutput = outputs[masterOutputIndex];

  if (!masterOutput) {
    return null;
  }

  const canUpdateMaster = canUpdateOutput({
    hasUpdatePermission,
    output: masterOutput,
    editingMode
  });
  const additionalOutputs = [...outputs];

  additionalOutputs.splice(masterOutputIndex, 1);

  const currencyIcon = getCurrencyIcon ? getCurrencyIcon() : '';

  useEffect(() => {
    setIterationsVisibility(outputs.length > 1);
  }, [outputs]);

  const handleToggleChange = () => {
    if (outputs.length === 1) {
      createNewOutput();
      return;
    }

    setInitialOutput(outputs.slice(0, 1));
    setIterationsVisibility(false);
  };

  return (
    <div className="social-iterations-v2" ref={iterationsBlockRef}>
      <ToggleValueAddon
        id="social-iteration"
        title="Social iterations"
        subtitle="Pending approval of master iteration"
        icon="aspectratio"
        costString={`${currencyIcon}${outputCost} each`}
        selected={areIterationsVisible}
        onChange={handleToggleChange}
        disabled={!canUpdateMaster}>

        <div className="social-iterations-v2__children">
          {areIterationsVisible &&
          <>
              {additionalOutputs.map((output, index) => {
              const key = `iteration-${output.outputId}-${index}`;
              const isLastOutput = index === additionalOutputs.length - 1;

              return (
                <SocialIteration
                  {...output}
                  isPodcast={isPodcast}
                  output={output}
                  outputIndex={index}
                  outputs={outputs}
                  assets={assets}
                  isMobile={isMobile}
                  onNotesChange={handleNotesChange}
                  onBlurField={onSave}
                  onChangeAddon={onChangeAddon(output.outputId)}
                  createNewOutput={createNewOutput}
                  deleteOutput={() => onDeleteOutput({
                    index,
                    setIterationsVisibility,
                    additionalOutputs,
                    deleteOutput
                  })}

                  updateOutputName={updateOutputName}
                  canUpdateVideo={canUpdateVideo}
                  canUpdateMaster={canUpdateMaster}
                  isLastOutput={isLastOutput}
                  getCurrencySymbol={getCurrencySymbol}
                  getCurrencyIcon={getCurrencyIcon}
                  outputCost={outputCost}
                  onChangeCost={onChangeCost(output.outputId)}
                  editingMode={hasUpdatePermission && editingMode}
                  key={key} />);


            })}
              {canUpdateVideo &&
            <div className="outputs-and-addons__social-iterations__header__action social-iterations-v2__additional">
                  <NewOutput
                disabled={!canUpdateMaster}
                onClick={createNewOutput} />

                </div>}

            </>}

        </div>
      </ToggleValueAddon>
    </div>);

}

SocialIterations.defaultProps = {
  editingMode: false
};

export default memo(SocialIterations);